import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, createSlots as _createSlots } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Op deze pagina kunt u een bezwaar of een servicemelding toevoegen."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Tevens staan hier de punten die genoteerd zijn tijdens de oplevering van uw woning.")
], -1)
const _hoisted_3 = {
  key: 0,
  id: "objection-info"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", null, "Bezwaar", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Bent u het niet eens met een besluit? Dan kunt u een bezwaar indienen op het betreffende document waarin het besluit is vastgesteld."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Klik dan op \"Bezwaren\" en vervolgens op \"Nieuw bezwaar\". ")
], -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  id: "service-info"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h4", null, "Servicemelding", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Wilt u een servicemelding doen of een reparatieverzoek indienen? Heeft u de handleiding(en) bij de documenten al bekeken? Wellicht vindt u daar eenvoudig en snel een antwoord op uw vraag. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Klik anders op \"Service meldingen\" en vervolgens op \"Nieuwe melding\" om een nieuwe melding aan te maken. ")
], -1)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  key: 2,
  id: "delivery-info"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h4", null, "Opleverpunt", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "no-mb" }, "Tijdens oplevering kan het voorkomen dan er onderdelen beschadigd zijn of niet helemaal goed werken. Deze punten staan onder het kopje “Opleverpunten” en worden zo snel mogelijk hersteld en of vervangen. Beschadigingen die zijn ontstaan na de oplevering worden niet meer in behandeling genomen.", -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { style: {"font-weight":"600"} }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { style: {"font-weight":"600"} }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = { style: {"font-weight":"600"} }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { useRouter } from 'vue-router'
import { headerStore } from '@/stores/header'
import { issueStore } from '@/stores/issue'
import { objectionStore } from '@/stores/objection'
import { onMounted } from 'vue'
import { IssueStatusColors } from '@/globalVariables'
import { generalStore } from '@/stores/general'
import FivePercentRulePanel from '@/components/service/FivePercentRulePanel.vue'
import { authStore } from '@/stores/auth'


export default /*#__PURE__*/_defineComponent({
  __name: 'Service',
  setup(__props) {

const router = useRouter()

const columns = [
  {
    title: 'Ref. nr.',
    key: 'reference'
  },
  {
    title: 'Onderwerp',
    key: 'subject'
  },
  {
    title: 'Gemeld op',
    key: 'created_at'
  },
  {
    title: 'Bijgewerkt op',
    key: 'updated_at'
  },
  {
    title: 'Status',
    key: 'status'
  }
]

onMounted(() => {
  issueStore().getIssues()
  objectionStore().getObjections()
})

function onObjectionRowClick (record:{ id:number }) {
  return {
    onClick: () => {
      router.push({ name: 'ObjectionShow', params: { objectionId: record.id.toString() } })
    }
  }
}

function onIssueRowClick (record:{ id:number }) {
  return {
    onClick: () => {
      router.push({ name: 'IssueShow', params: { issueId: record.id.toString() } })
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_list_item_meta = _resolveComponent("a-list-item-meta")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_row, { gutter: [16,16] }, {
    default: _withCtx(() => [
      (_unref(generalStore)().appSettings?.notification?.pages.includes('Service'))
        ? (_openBlock(), _createBlock(_component_a_col, {
            key: 0,
            xs: {span: 24},
            sm: {span: 24},
            md: {span: 24},
            lg: {span: 18, offset: 3}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_alert, {
                type: "info",
                class: "global-notification mb-16",
                message: _unref(generalStore)().appSettings.notification.title,
                "show-icon": ""
              }, {
                description: _withCtx(() => [
                  _createElementVNode("div", {
                    innerHTML: _unref(generalStore)().appSettings.notification.description
                  }, null, 8, _hoisted_1)
                ]),
                _: 1
              }, 8, ["message"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_a_col, {
        xs: {span: 24},
        sm: {span: 24},
        md: {span: 24},
        lg: {span: 18, offset: 3}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, {
            title: "Service",
            loading: _unref(issueStore)().loading || _unref(objectionStore)().loading
          }, _createSlots({
            default: _withCtx(() => [
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _hoisted_2,
                      (_unref(headerStore)().buildingSold && !_unref(headerStore)().buildingDelivered)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
                        : _createCommentVNode("", true),
                      (_unref(headerStore)().buildingDelivered)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_10))
                        : _createCommentVNode("", true),
                      (_unref(headerStore)().buildingDelivered && _unref(issueStore)().deliveryIssues.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_14))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_collapse, null, {
                        default: _withCtx(() => [
                          (_unref(headerStore)().buildingSold && !_unref(headerStore)().buildingDelivered)
                            ? (_openBlock(), _createBlock(_component_a_collapse_panel, { key: 0 }, {
                                header: _withCtx(() => [
                                  _createElementVNode("b", _hoisted_15, "Bezwaren (" + _toDisplayString(_unref(objectionStore)().objections.length) + ")", 1)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_a_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_col, { span: 24 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_button, {
                                            disabled: _unref(authStore)().restricted(),
                                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push({ name: 'ObjectionCreate' })))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("Nieuw bezwaar")
                                            ]),
                                            _: 1
                                          }, 8, ["disabled"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_a_row, { class: "no-mb" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_col, { span: 24 }, {
                                        default: _withCtx(() => [
                                          (_unref(generalStore)().desktop)
                                            ? (_openBlock(), _createBlock(_component_a_table, {
                                                key: 0,
                                                columns: columns,
                                                "data-source": _unref(objectionStore)().objections,
                                                loading: _unref(objectionStore)().loading,
                                                pagination: false,
                                                "custom-row": onObjectionRowClick,
                                                "row-key": "id",
                                                "row-class-name": "clickable-row"
                                              }, {
                                                bodyCell: _withCtx(({ column, record }) => [
                                                  (column.key === 'reference')
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        _createTextVNode(_toDisplayString(record.id), 1)
                                                      ], 64))
                                                    : _createCommentVNode("", true),
                                                  (column.key === 'subject')
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                        _createTextVNode(_toDisplayString(record.title), 1)
                                                      ], 64))
                                                    : _createCommentVNode("", true),
                                                  (column.key === 'created_at')
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                        _createTextVNode(_toDisplayString(record.created_at ? new Date(record.created_at).toLocaleDateString('nl-NL') : '-'), 1)
                                                      ], 64))
                                                    : _createCommentVNode("", true),
                                                  (column.key === 'updated_at')
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                        _createTextVNode(_toDisplayString(record.updated_at ? new Date(record.updated_at).toLocaleDateString('nl-NL') : '-'), 1)
                                                      ], 64))
                                                    : _createCommentVNode("", true),
                                                  (column.key === 'status')
                                                    ? (_openBlock(), _createBlock(_component_a_tag, {
                                                        key: 4,
                                                        color: _unref(IssueStatusColors)[record.status.id]
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(record.status.name), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["color"]))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 1
                                              }, 8, ["data-source", "loading"]))
                                            : (_openBlock(), _createBlock(_component_a_list, {
                                                key: 1,
                                                "data-source": _unref(objectionStore)().objections,
                                                "item-layout": "vertical",
                                                pagination: false
                                              }, {
                                                renderItem: _withCtx(({ item }) => [
                                                  _createVNode(_component_a_list_item, {
                                                    style: { padding: '16px 0' },
                                                    onClick: ($event: any) => (_unref(router).push({ name: 'ObjectionShow', params: { objectionId: item.id.toString() } }))
                                                  }, {
                                                    actions: _withCtx(() => [
                                                      _createVNode(_component_a_tag, {
                                                        color: _unref(IssueStatusColors)[item.status.id]
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(item.status.name), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["color"])
                                                    ]),
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_a_list_item_meta, null, {
                                                        title: _withCtx(() => [
                                                          _createTextVNode("#" + _toDisplayString(item.id) + " - " + _toDisplayString(item.title), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1024),
                                                      _createTextVNode(" Gemeld op: " + _toDisplayString(item.created_at ? new Date(item.created_at).toLocaleDateString('nl-NL') : '-'), 1),
                                                      _hoisted_16,
                                                      _createTextVNode(" Bijgewerkt op: " + _toDisplayString(item.updated_at ? new Date(item.updated_at).toLocaleDateString('nl-NL') : '-'), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"])
                                                ]),
                                                _: 1
                                              }, 8, ["data-source"]))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_unref(headerStore)().buildingDelivered)
                            ? (_openBlock(), _createBlock(_component_a_collapse_panel, { key: 1 }, {
                                header: _withCtx(() => [
                                  _createElementVNode("b", _hoisted_17, "Servicemeldingen (" + _toDisplayString(_unref(issueStore)().issues.length) + ")", 1)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_a_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_col, { span: 24 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_button, {
                                            disabled: _unref(authStore)().restricted(),
                                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push({ name: 'IssueCreate' })))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("Nieuwe servicemelding")
                                            ]),
                                            _: 1
                                          }, 8, ["disabled"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_a_row, { class: "no-mb" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_col, { span: 24 }, {
                                        default: _withCtx(() => [
                                          (_unref(generalStore)().desktop)
                                            ? (_openBlock(), _createBlock(_component_a_table, {
                                                key: 0,
                                                columns: columns,
                                                "data-source": _unref(issueStore)().issues,
                                                loading: _unref(issueStore)().loading,
                                                pagination: false,
                                                "custom-row": onIssueRowClick,
                                                "row-key": "id",
                                                "row-class-name": "clickable-row"
                                              }, {
                                                bodyCell: _withCtx(({ column, record }) => [
                                                  (column.key === 'reference')
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        _createTextVNode(_toDisplayString(record.id), 1)
                                                      ], 64))
                                                    : _createCommentVNode("", true),
                                                  (column.key === 'subject')
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                        _createTextVNode(_toDisplayString(record.title), 1)
                                                      ], 64))
                                                    : _createCommentVNode("", true),
                                                  (column.key === 'created_at')
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                        _createTextVNode(_toDisplayString(record.created_at ? new Date(record.created_at).toLocaleDateString('nl-NL') : '-'), 1)
                                                      ], 64))
                                                    : _createCommentVNode("", true),
                                                  (column.key === 'updated_at')
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                        _createTextVNode(_toDisplayString(record.updated_at ? new Date(record.updated_at).toLocaleDateString('nl-NL') : '-'), 1)
                                                      ], 64))
                                                    : _createCommentVNode("", true),
                                                  (column.key === 'status')
                                                    ? (_openBlock(), _createBlock(_component_a_tag, {
                                                        key: 4,
                                                        color: _unref(IssueStatusColors)[record.status.id]
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(record.status.name), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["color"]))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 1
                                              }, 8, ["data-source", "loading"]))
                                            : (_openBlock(), _createBlock(_component_a_list, {
                                                key: 1,
                                                "data-source": _unref(issueStore)().issues,
                                                "item-layout": "vertical",
                                                pagination: false
                                              }, {
                                                renderItem: _withCtx(({ item }) => [
                                                  _createVNode(_component_a_list_item, {
                                                    style: { padding: '16px 0' },
                                                    onClick: ($event: any) => (_unref(router).push({ name: 'IssueShow', params: { issueId: item.id.toString() } }))
                                                  }, {
                                                    actions: _withCtx(() => [
                                                      _createVNode(_component_a_tag, {
                                                        color: _unref(IssueStatusColors)[item.status.id]
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(item.status.name), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["color"])
                                                    ]),
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_a_list_item_meta, null, {
                                                        title: _withCtx(() => [
                                                          _createTextVNode("#" + _toDisplayString(item.id) + " - " + _toDisplayString(item.title), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1024),
                                                      _createTextVNode(" Gemeld op: " + _toDisplayString(item.created_at ? new Date(item.created_at).toLocaleDateString('nl-NL') : '-'), 1),
                                                      _hoisted_18,
                                                      _createTextVNode(" Bijgewerkt op: " + _toDisplayString(item.updated_at ? new Date(item.updated_at).toLocaleDateString('nl-NL') : '-'), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"])
                                                ]),
                                                _: 1
                                              }, 8, ["data-source"]))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_unref(headerStore)().buildingDelivered && _unref(issueStore)().deliveryIssues.length)
                            ? (_openBlock(), _createBlock(_component_a_collapse_panel, { key: 2 }, {
                                header: _withCtx(() => [
                                  _createElementVNode("b", _hoisted_19, "Opleverpunten (" + _toDisplayString(_unref(issueStore)().deliveryIssues.length) + ")", 1)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_a_row, { class: "no-mb" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_col, { span: 24 }, {
                                        default: _withCtx(() => [
                                          (_unref(generalStore)().desktop)
                                            ? (_openBlock(), _createBlock(_component_a_table, {
                                                key: 0,
                                                columns: columns,
                                                "data-source": _unref(issueStore)().deliveryIssues,
                                                loading: _unref(issueStore)().loading,
                                                pagination: false,
                                                "custom-row": onIssueRowClick,
                                                "row-key": "id",
                                                "row-class-name": "clickable-row"
                                              }, {
                                                bodyCell: _withCtx(({ column, record }) => [
                                                  (column.key === 'reference')
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        _createTextVNode(_toDisplayString(record.id), 1)
                                                      ], 64))
                                                    : _createCommentVNode("", true),
                                                  (column.key === 'subject')
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                        _createTextVNode(_toDisplayString(record.title), 1)
                                                      ], 64))
                                                    : _createCommentVNode("", true),
                                                  (column.key === 'created_at')
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                        _createTextVNode(_toDisplayString(record.created_at ? new Date(record.created_at).toLocaleDateString('nl-NL') : '-'), 1)
                                                      ], 64))
                                                    : _createCommentVNode("", true),
                                                  (column.key === 'updated_at')
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                        _createTextVNode(_toDisplayString(record.updated_at ? new Date(record.updated_at).toLocaleDateString('nl-NL') : '-'), 1)
                                                      ], 64))
                                                    : _createCommentVNode("", true),
                                                  (column.key === 'status')
                                                    ? (_openBlock(), _createBlock(_component_a_tag, {
                                                        key: 4,
                                                        color: _unref(IssueStatusColors)[record.status.id]
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(record.status.name), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["color"]))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _: 1
                                              }, 8, ["data-source", "loading"]))
                                            : (_openBlock(), _createBlock(_component_a_list, {
                                                key: 1,
                                                "data-source": _unref(issueStore)().deliveryIssues,
                                                "item-layout": "vertical",
                                                pagination: false
                                              }, {
                                                renderItem: _withCtx(({ item }) => [
                                                  _createVNode(_component_a_list_item, {
                                                    style: { padding: '16px 0' },
                                                    onClick: ($event: any) => (_unref(router).push({ name: 'IssueShow', params: { issueId: item.id.toString() } }))
                                                  }, {
                                                    actions: _withCtx(() => [
                                                      _createVNode(_component_a_tag, {
                                                        color: _unref(IssueStatusColors)[item.status.id]
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(item.status.name), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["color"])
                                                    ]),
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_a_list_item_meta, null, {
                                                        title: _withCtx(() => [
                                                          _createTextVNode("#" + _toDisplayString(item.id) + " - " + _toDisplayString(item.title), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1024),
                                                      _createTextVNode(" Gemeld op: " + _toDisplayString(item.created_at ? new Date(item.created_at).toLocaleDateString('nl-NL') : '-'), 1),
                                                      _hoisted_20,
                                                      _createTextVNode(" Bijgewerkt op: " + _toDisplayString(item.updated_at ? new Date(item.updated_at).toLocaleDateString('nl-NL') : '-'), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"])
                                                ]),
                                                _: 1
                                              }, 8, ["data-source"]))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(FivePercentRulePanel)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 2
          }, [
            (_unref(generalStore)().desktop)
              ? {
                  name: "extra",
                  fn: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'Dashboard' })))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Terug naar dashboard")
                      ]),
                      _: 1
                    })
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["loading"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})